import { render, staticRenderFns } from "./shopMainpage.vue?vue&type=template&id=1b53466c"
import script from "./shopMainpage.vue?vue&type=script&lang=js"
export * from "./shopMainpage.vue?vue&type=script&lang=js"
import style0 from "./shopMainpage.vue?vue&type=style&index=0&id=1b53466c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports